import React from 'react';
import UserDefinedRegionMapForm from '../UserDefinedRegion/UserDefinedRegionMapForm';
import DownloadableGISDataForm from '../DownloadableGISData/DownloadGISDataForm';
import STPDataMapForm from '../STPData/STPDataMapForm';
import Cart from '../FloatCart/Cart';
import '../FloatCart/FloatCart.css';
import './NavTab.css';

class ServiceCatalogForm extends React.Component {

    // Then we add our constructor which receives our props
    constructor(props) {
        super(props);
        // Next we establish our state
        this.state = {
            cartItems: JSON.parse(localStorage.getItem("cartItems")) || [],
            cartGISData: JSON.parse(localStorage.getItem("cartGISData")) || [],
            cartSTPData: JSON.parse(localStorage.getItem("cartSTPData")) || [],
            sketchGeometries: JSON.parse(localStorage.getItem("sketchGeometries")) || [],
            countSTPChange: 0,
        }
        // To use the 'this' keyword, we need to bind it to our function
        this.onChange = this.onChange.bind(this);

    }

    componentDidMount() {
    }

    addToCartItem(item) {
        this.setState(state => {
            const sketchGeometries = state.sketchGeometries.map((sketchGeometry) => {
                if (sketchGeometry.BufferId === item.BufferId) {
                    sketchGeometry.AddToCart = true;
                    return sketchGeometry;
                } else {
                    return sketchGeometry;
                }
            });
            return {
                sketchGeometries,
            };
        },
            function () { localStorage.setItem('sketchGeometries', JSON.stringify(this.state.sketchGeometries)); }
        );

        this.setState({
            cartItems: [...this.state.cartItems, item]
        },
            function () { localStorage.setItem('cartItems', JSON.stringify(this.state.cartItems)); }
        );
    };

    removeCartItem(item) {
        this.setState(state => {
            const sketchGeometries = state.sketchGeometries.map((sketchGeometry) => {
                if (sketchGeometry.BufferId === item.BufferId) {
                    sketchGeometry.AddToCart = false;
                    return sketchGeometry;
                } else {
                    return sketchGeometry;
                }
            });
            return {
                sketchGeometries,
            };
        },
            function () { localStorage.setItem('sketchGeometries', JSON.stringify(this.state.sketchGeometries)); }
        );

        this.setState({
            cartItems: this.state.cartItems.filter(i => i.BufferId !== item.BufferId)
        },
            function () { localStorage.setItem('cartItems', JSON.stringify(this.state.cartItems)); }
        );
    }

    addToCartGISData() {
        var gisData = JSON.parse(localStorage.getItem("dataChkGISState"));
        var checkedGisData = gisData.filter(i => i.checked === true);
        //console.log(checkedGisData);

        this.setState({
            cartGISData: checkedGisData
        },
            function () { localStorage.setItem('cartGISData', JSON.stringify(this.state.cartGISData)); }
        );
    }

    removeCartGISData(item) {
        this.setState({
            cartGISData: this.state.cartGISData.filter(i => i.productId !== item.productId)
        },
            function () { localStorage.setItem('cartGISData', JSON.stringify(this.state.cartGISData)); }
        );
    }

    addToCartSTPData(item) {
        localStorage.cartSTPData = JSON.stringify(item)
        this.setState({
            cartSTPData: item
        })
    }

    async removeCartSTPData(item) {
        await this.setState({
            cartSTPData: this.state.cartSTPData.filter(stpData => stpData.assetNumber !== item.assetNumber),
        }, () => {
                localStorage.cartSTPData = JSON.stringify(this.state.cartSTPData)
            })
        this.setState({
            countSTPChange: this.state.countSTPChange + 1
        })
    }

    onSetState(sketchGeometries) {
        this.setState({ sketchGeometries: sketchGeometries },
            function () {
                localStorage.setItem('sketchGeometries', JSON.stringify(this.state.sketchGeometries));
            }
        ); 

        this.setState({
            cartItems: sketchGeometries.filter(i => i.AddToCart === true)
        },
            function () { localStorage.setItem('cartItems', JSON.stringify(this.state.cartItems)); }
        );
    }

    // A custom function to change the name in our state to match the user input
    onChange(e) {
        this.setState({
            name: e.target.value
        })
    }

    // The render function, where we actually tell the browser what it should show
    render() {
        return (
            <div>
                {/*<section className="section">
                    <label className="label">Name:</label>
                    <input className="input" name="name" placeholder="Enter your name..." onChange={this.onChange}/>
                </section>
                <section className="section">
                    <p>{this.state.greeting} {this.state.name}</p>
                </section>*/}

                <div className="pl-md-5 pr-md-5 pt-md-2 pb-md-2">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <nav>
                                <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                    <a className="nav-item nav-link active" id="nav-user-tab" data-toggle="tab" href="#nav-user" role="tab" aria-controls="nav-user" aria-selected="true">User Defined Region</a>
                                    <a className="nav-item nav-link" id="nav-downloadable-tab" data-toggle="tab" href="#nav-downloadable" role="tab" aria-controls="nav-downloadable" aria-selected="false">Downloadable GIS Data by State (Public Plant only)</a>
                                    <a className="nav-item nav-link" id="nav-data-tab" data-toggle="tab" href="#nav-data" role="tab" aria-controls="nav-data" aria-selected="false">Sewage Treatment Plant Data</a>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="nav-user" role="tabpanel" aria-labelledby="nav-user-tab">
                                    <UserDefinedRegionMapForm config={this.props.config} cartItems={this.state.cartItems} sketchGeometries={this.state.sketchGeometries} addToCartItem={(item) => this.addToCartItem(item)} onSetState={(sketchGeometries) => this.onSetState(sketchGeometries)}></UserDefinedRegionMapForm>
                                </div>
                                <div className="tab-pane fade" id="nav-downloadable" role="tabpanel" aria-labelledby="nav-downloadable-tab">
                                    <DownloadableGISDataForm config={this.props.config} addToCartGISData={() => this.addToCartGISData()}></DownloadableGISDataForm>
                                </div>
                                <div className="tab-pane fade" id="nav-data" role="tabpanel" aria-labelledby="nav-data-tab">
                                    <STPDataMapForm config={this.props.config} addToCartSTPData={(item) => this.addToCartSTPData(item)} countSTPChange={this.state.countSTPChange}/>
                                </div>
                            </div>

                        </div>
                    </div>

                    <Cart cartItems={this.state.cartItems} cartGISData={this.state.cartGISData} cartSTPData={this.state.cartSTPData} removeCartItem={(product) => this.removeCartItem(product)} removeCartGISData={(product) => this.removeCartGISData(product)} removeCartSTPData={(product)=> this.removeCartSTPData(product)}></Cart>
                </div>


            </div>
        )
    }
}

export default ServiceCatalogForm;


// WEBPACK FOOTER //
// ./src/components/ServiceCatalog/ServiceCatalogForm.js